export default [
  {
    header: "About Us",
    items: [
      {
        path: "/blog",
        label: "Blog",
      },
      {
        path: "https://www.teamtopspin.com",
        label: "TopSpin",
      },
      {
        path: "mailto:careers@onecoachapp.com?subject=Become a coach",
        label: "Become a Coach",
      },
      {
        path: "mailto:careers@onecoachapp.com?subject=Become an ambassador",
        label: "Become an Ambassador",
      },
    ],
  },
  {
    header: "Check Out",
    items: [
      {
        path: "/app/programs",
        label: "Online Tennis Programs",
      },
      {
        path: "/app/program/intro-to-tennis",
        label: "Intro to Tennis (Beginner Program)",
      },
      {
        path: "/app/program/low-intermediate-tennis",
        label: "Low Intermediate Tennis (2.0 to 3.0 Program)",
      },
    ],
  },
  {
    header: "Legal Bits",
    items: [
      {
        path: "/privacy",
        label: "Privacy Policy",
      },
      {
        path: "/terms",
        label: "Terms of Service",
      },
      // {
      //   path: "/sitemap.xml",
      //   label: "Site Map",
      // },
      // {
      //   path: '/',
      //   label: 'Store Hours',
      // },
    ],
  },
  {
    header: "Download Now",
    items: [
      {
        path: "/ios",
        label: "Apple iOS",
      },
      {
        path: "/android",
        label: "Android Play Store",
      },
    ],
  },
  // {
  //   header: 'Policy',
  //   items: [
  //     {
  //       path: '/',
  //       label: 'Application security',
  //     },
  //     {
  //       path: '/',
  //       label: 'Software principles',
  //     },
  //     {
  //       path: '/',
  //       label: 'Unwanted software policy',
  //     },
  //     {
  //       path: '/',
  //       label: 'Responsible supply chain',
  //     },
  //   ],
  // },
];
